import React from "react";
import AddEditUserWidget from "./AddEditUserWidget";
import { useParams } from "react-router-dom";

const EditUser = () => {
  let { userId } = useParams<{ userId: string }>();

  return (
    <React.Fragment>
      <AddEditUserWidget userId={userId} />
    </React.Fragment>
  );
};

export default EditUser;
